import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import api from "@/lib/api";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Reveal, SectionLabel } from "./Reveal";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const data = useSite();
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("সব");

  useEffect(() => { api.get("/public/blog").then((r) => setPosts(r.data)); }, []);

  const cats = ["সব", ...Array.from(new Set(posts.map((p) => p.category).filter(Boolean)))];
  const shown = cat === "সব" ? posts : posts.filter((p) => p.category === cat);

  return (
    <div className="min-h-screen bg-[var(--c-bg)]">
      <Navbar site={data?.site} />
      <main className="pt-[120px] pb-24 paper-texture">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <Reveal className="text-center max-w-2xl mx-auto">
            <SectionLabel>শ্রুতি ব্লগ</SectionLabel>
            <h1 className="font-heading font-bold text-[var(--c-primary)] mt-5 text-4xl sm:text-5xl">কবিতা ও সংস্কৃতির কথা</h1>
            <p className="font-body text-[var(--c-muted)] mt-4 text-lg">আবৃত্তি, সাহিত্য ও সাংস্কৃতিক চর্চা নিয়ে আমাদের লেখা।</p>
          </Reveal>

          <div className="flex flex-wrap justify-center gap-2 mt-10">
            {cats.map((c) => (
              <button key={c} onClick={() => setCat(c)} className={`rounded-full px-5 py-2 text-sm font-body transition-colors ${cat === c ? "bg-[var(--c-primary)] text-white" : "bg-[var(--c-card)] border border-[var(--c-border)] text-[var(--c-text)] hover:border-[var(--c-accent)]"}`}>{c}</button>
            ))}
          </div>

          {shown.length === 0 ? (
            <p className="text-center text-[var(--c-muted)] mt-16">কোনো পোস্ট নেই।</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7 mt-12">
              {shown.map((p, i) => (
                <Reveal key={p.slug} delay={(i % 3) * 0.08}>
                  <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${i}`} className="group block h-full bg-[var(--c-card)] rounded-2xl border border-[var(--c-border)] overflow-hidden hover:-translate-y-1 hover:shadow-[0_25px_60px_-30px_rgba(106,27,26,0.4)] transition-[transform,box-shadow] duration-300">
                    <div className="h-48 overflow-hidden">
                      <img src={p.featured_image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 duration-700 ease-out" />
                    </div>
                    <div className="p-6">
                      <span className="font-body text-xs tracking-widest uppercase text-[var(--c-secondary)]">{p.category}</span>
                      <h3 className="font-heading text-xl font-semibold text-[var(--c-primary)] mt-2 leading-snug">{p.title}</h3>
                      <p className="font-body text-sm text-[var(--c-muted)] mt-3 leading-relaxed line-clamp-3">{p.excerpt}</p>
                      <span className="inline-flex items-center gap-1 font-body text-sm text-[var(--c-secondary)] mt-4 group-hover:gap-2 transition-all">পড়ুন <ArrowRight className="h-4 w-4" /></span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer site={data?.site} />
    </div>
  );
}
